import React, { FC } from 'react';

const LoaderIcon: FC<{variant: string}> = ({ variant = 'primary' }: {variant: string}) =>
  <svg version="1.1" className="loader" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
    x="0px" y="0px" width="12px" height="12px" viewBox="0 0 12 12">
    <circle className={`circle ${variant}`} fill="none" cx="6" cy="6" r="6" stroke="#ff4081 " strokeWidth="2" />
  </svg>;

export default LoaderIcon;
